import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconLeaderboardsOff1 = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={24}
    fill="none"
    viewBox="0 0 25 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="url(#icon-leaderboards-off-1_svg__a)"
      d="M23.36.047c.843 0 1.64.562 1.64 1.406V15.61c0 .563-.375 1.079-.938 1.313C22.047 17.719 20.407 18 19 18c-3.375 0-5.672-1.453-9-1.453-1.688 0-3.61.375-6 1.453v5.25c0 .422-.375.75-.75.75H1.703c-.375 0-.75-.328-.75-.75L1 1.5C1 .703 1.656 0 2.5 0 3.297 0 4 .703 4 1.5v.047C6.672.422 8.64.047 10.188.047c3.14 0 4.687 1.5 7.406 1.5 1.312 0 2.812-.328 4.875-1.313.281-.14.61-.187.89-.187ZM22 6.657V3.702c-1.36.469-2.578.75-3.75.797v3.234c-.234 0-.469.047-.656.047-1.172 0-2.157-.281-3.094-.61V4.079c-.469-.14-.89-.281-1.266-.422-.89-.281-1.64-.515-2.484-.562V6.28h-.563c-.89 0-1.968.14-3.187.469V3.656c-.61.14-1.219.375-1.875.656L4 4.782v3c1.125-.47 2.063-.798 3-1.032v3.844c-.61.187-1.219.422-1.875.703L4 11.766v3c.984-.422 2.016-.704 3-.938v-3.234c1.172-.375 2.25-.563 3.188-.563h.562v3.563c1.36.047 2.625.281 3.75.562v-3.094c.89.235 1.875.47 3.094.47.234 0 .422-.048.656-.048V15h.703c.985 0 1.969-.14 3.047-.516v-3.796c-1.36.468-2.578.75-3.75.796v-3.75c1.031-.093 2.25-.421 3.75-1.078ZM10.75 6.28c1.453.094 2.625.516 3.75.89v3.891c-.469-.14-.89-.28-1.266-.421-.89-.282-1.64-.516-2.484-.61v-3.75Z"
    />
    <defs>
      <linearGradient
        id="icon-leaderboards-off-1_svg__a"
        x1={26.5}
        x2={2.666}
        y1={0}
        y2={26.814}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF968D" />
        <stop offset={0.18} stopColor="#E2645A" />
        <stop offset={0.73} stopColor="#D83832" />
        <stop offset={1} stopColor="#AD3529" />
      </linearGradient>
    </defs>
  </svg>
));
export default SvgIconLeaderboardsOff1;
